// libraries
import React, { useEffect, useRef, useState, useLayoutEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

// styles
import styles from "./styles.module.scss";

// assets
import airplane from "src/assets/images/home/airplane.svg";
import prevArrow from "src/assets/images/home/chevron_left.svg";
import nextArrow from "src/assets/images/home/chevron_right.svg";

// animation
import FadeTop from "src/components/Animation/FadeTop";

const HorizontalBar = ({ setShowForm, data, onChange, active }) => {
  // ref
  const scrollRef = useRef();
  const activeTagRef = useRef();

  const [isVisible, setIsVisible] = useState(false);

  useLayoutEffect(() => {
    if (window.innerWidth < 640) {
      setIsVisible(true);
    }
  }, []);

  useEffect(() => {
    if (active && activeTagRef) {
      let offset = activeTagRef?.current?.getBoundingClientRect();
      if (offset) scroll([offset?.x - 120, offset?.x - 20]);
    }
  }, [active]);

  useEffect(() => {
    window.window.addEventListener("resize", handleResize);
    window.addEventListener("scroll", listenToScroll);

    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("scroll", listenToScroll);
    };
  }, []);

  const listenToScroll = () => {
    if (window.innerWidth > 640) {
      if (window.scrollY > 600) {
        // 1200
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    }
  };

  const handleResize = () => {
    if (window.innerWidth < 640) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  const handleShowForm = () => {
    if (window.innerWidth < 640) {
      setTimeout(() => {
        document.body.classList.add("set-y");
      }, 500);
    }

    setShowForm(true);
  };

  const scroll = (_offsets) => {
    let offset = 0;
    if (window.innerWidth > 640) {
      offset = _offsets[0];
    } else {
      offset = _offsets[1];
    }

    let x = scrollRef.current.scrollLeft + offset;
    scrollRef.current.scroll({ top: 0, left: x, behavior: "smooth" });
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          className={styles.horizontal_bar}
        >
          <FadeTop duration={0.5} y={-20}>
            <div className={styles.wrap}>
              <motion.span
                whileTap={{ scale: 0.9 }}
                className={styles.icon__wrapper}
                onClick={() => scroll([-300, -150])}
              >
                <img src={prevArrow} alt="prev arrow" />
              </motion.span>
              <div className={styles.tags} ref={scrollRef} id="test">
                {data.map((item, index) => (
                  <span
                    ref={
                      item.Categoryid === active.Categoryid
                        ? activeTagRef
                        : null
                    }
                    key={index}
                    onClick={() => {
                      // setActive(item.Categoryid);
                      onChange(item);
                    }}
                    className={
                      item.Categoryid === active.Categoryid ? styles.active : ""
                    }
                  >
                    {item.CategoryName}
                  </span>
                ))}
              </div>
              <motion.span
                whileTap={{ scale: 0.9 }}
                className={styles.icon__wrapper}
                onClick={() => scroll([300, 150])}
              >
                <img src={nextArrow} alt="next arrow" />
              </motion.span>
              {data && (
                <img
                  className={styles.icon}
                  onClick={handleShowForm}
                  src={airplane}
                  alt="airplane"
                />
              )}
            </div>
          </FadeTop>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default HorizontalBar;
